/**
 *
 * styled Pricing
 *
 */
import styled from 'styled-components';

export const NotfoundWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #393839;
  .topLogo {
    position: absolute;
    top: 35px;
    left: 35px;
    cursor: pointer;
    width: 250px;
    img {
      width: 100%;
    }
  }
  .mainBlock {
    text-align: center;
    margin-bottom: 70px;
    .bgBox {
      height: 300px;
      img {
        width: 300px;
      }
    }
    h3 {
      color: #fff;
      font-weight: 700;
      font-size: 50px;
      margin-bottom: 0;
    }
    p {
      margin-top: 5px;
      color: #777;
      font-size: 18px;
      font-weight: 300;
    }
    button {
      cursor: pointer;
      margin-top: 20px;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      color: #fff;
      background-image: linear-gradient(to right, #850054, #f05a21);
    }
  }
`;
